// baseURL.js
export const BASE_URL =
	window.location.hostname === "localhost" ? "http://localhost:3000/api/v1" : "https://dev-irecruit-api.webpipl.com/api/v1";
